const CHUNK_RELOAD_KEY = "__chunk_reload_once__";

const CHUNK_ERROR_PATTERNS = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "ChunkLoadError",
];

export const isChunkLoadError = error => {
  const message = typeof error === "string" ? error : error?.message || error?.reason?.message || "";

  if (!message) return false;

  return CHUNK_ERROR_PATTERNS.some(pattern => message.includes(pattern));
};

export const clearChunkReloadFlag = () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
};

/** Clears the reload guard after a successful page load following a chunk-error reload. */
export const resetChunkReloadGuardIfNeeded = () => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") {
    clearChunkReloadFlag();
  }
};

/**
 * Reloads the page once per chunk-error cycle to fetch the latest asset manifest.
 * @returns {boolean} true when a reload was triggered
 */
export const reloadOnceForChunkError = () => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") return false;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
  return true;
};
